import { Outlet } from 'react-router';
import { HeroUIProvider } from '@heroui/react';
import { useNavigate } from 'react-router';
import { render } from '@/routing/render';

export const Layout = render(() => {
  const navigate = useNavigate();

  return (
    <HeroUIProvider navigate={navigate}>
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Outlet />
      </div>
    </HeroUIProvider>
  );
});
